import React, { useState } from "react";
import ChartDialog from "./ChartDialog.js";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import Button from "components/CustomButtons/Button.js";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import { Menu, MenuItem } from "@mui/material";
import ChartDialogV2 from "./ChartDialogV2.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function AddChartToView(props) {
  const [open, setOpen] = useState(false); 
  const [open2, setOpen2] = useState(false);
  const [openMenu, setOpenMenu] = React.useState(null);
  const classes = useStyles();
  const handleClickMenu = (event) => {
    setOpenMenu(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  }; 
  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  return (
    <>
      <div>
        <Tooltip title="Ajouter un graphique">
          <Button
            onClick={handleClickMenu}
            color={"success"}
            className={classes.actionButton}
          >
            <AddIcon fontSize="large" />
          </Button>
        </Tooltip>
        <Dialog
          onClose={handleClose}
          aria-labelledby="addMarket-dialog-title"
          fullWidth={true}
          maxWidth="sm"
          open={open}
        >
          <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
            Ajout d'un graphique
          </CustomDialogTitle>
          <DialogContent dividers>
            <ChartDialog closeModal={handleClose} {...props} />
          </DialogContent>
          <DialogActions />
        </Dialog>
        <Dialog
          onClose={handleClose2}
          aria-labelledby="addMarket-dialog-title"
          fullWidth={true}
          maxWidth="lg"
          open={open2}
        >
          <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose2}>
            Ajout d'un graphique
          </CustomDialogTitle>
          <ChartDialogV2 closeModal={handleClose2} {...props} />
        </Dialog>
      </div>
      <Menu
        id="chart-menu"
        className={"chart-menu"}
        anchorEl={openMenu}
        keepMounted
        aria-haspopup={'menu'}
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
      >
        <MenuItem
          onClick={() => {
            handleClickOpen();
            handleCloseMenu();
          }}
          key={`handlegroup`}>
          Graphique simple
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClickOpen2();
            handleCloseMenu();
          }}
          key={`handledetail`}>
          Graphique avancé
        </MenuItem>
      </Menu>
    </>
  );
}
